import React from 'react';
import { Check, X, Clock, ChevronRight } from 'lucide-react';

const WorkflowVisualizer = ({ steps = [], currentStepIndex = 0, workflowStatus = 'brouillon' }) => {
  if (!steps || steps.length === 0) return null;

  const getStepStatus = (index) => {
    if (workflowStatus === 'rejetee' && index === currentStepIndex) return 'rejected';
    if (workflowStatus === 'modification_demandee' && index === currentStepIndex) return 'modification';
    if (index < currentStepIndex) return 'completed';
    if (index === currentStepIndex && workflowStatus === 'en_validation') return 'current';
    if (workflowStatus === 'validee') return 'completed';
    return 'pending';
  };

  const getStepStyle = (status) => {
    switch (status) {
      case 'completed': return 'bg-green-500 text-white border-green-500';
      case 'current': return 'bg-blue-500 text-white border-blue-500 animate-pulse';
      case 'rejected': return 'bg-red-500 text-white border-red-500';
      case 'modification': return 'bg-orange-500 text-white border-orange-500';
      default: return 'bg-gray-200 text-gray-500 border-gray-300 dark:bg-gray-700 dark:border-gray-600';
    }
  };

  const getLineStyle = (index) => {
    if (index < currentStepIndex || workflowStatus === 'validee') return 'bg-green-500';
    return 'bg-gray-300 dark:bg-gray-600';
  };

  const getStepIcon = (status, index) => {
    switch (status) {
      case 'completed': return <Check className="w-4 h-4" />;
      case 'rejected': return <X className="w-4 h-4" />;
      case 'current': return <Clock className="w-4 h-4" />;
      case 'modification': return <ChevronRight className="w-4 h-4" />;
      default: return <span className="text-xs font-bold">{index + 1}</span>;
    }
  };

  return (
    <div className="flex items-center w-full overflow-x-auto py-4">
      {steps.map((step, index) => {
        const status = getStepStatus(index);
        return (
          <React.Fragment key={index}>
            <div className="flex flex-col items-center min-w-[80px]">
              <div className={`w-10 h-10 rounded-full flex items-center justify-center border-2 transition-all ${getStepStyle(status)}`}>
                {getStepIcon(status, index)}
              </div>
              <span className="text-xs mt-2 text-center max-w-[100px] font-medium text-slate-700 dark:text-slate-300">
                {step.nom}
              </span>
              {step.required_role && (
                <span className="text-[10px] text-slate-400 dark:text-slate-500">{step.required_role}</span>
              )}
            </div>
            {index < steps.length - 1 && (
              <div className={`flex-1 h-0.5 min-w-[20px] mx-1 ${getLineStyle(index)}`} />
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default WorkflowVisualizer;
